import React, { ChangeEvent } from 'react';
import { FormControlLabel, Grid, Switch, Typography } from '@mui/material';
import {
	CurrencyField,
	HTMLTextAreaElementExtended,
} from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations';

interface CostOverrideFieldProps {
	isOverride: boolean;
	overrideAmount: number;
	disabled: boolean;
	onToggle: (checked: boolean) => void;
	onAmountChange: (
		event: ChangeEvent<HTMLInputElement | HTMLTextAreaElementExtended>,
	) => void;
}

export const CostOverrideField = ({
	isOverride,
	overrideAmount,
	disabled,
	onToggle,
	onAmountChange,
}: CostOverrideFieldProps) => {
	const { t } = useGlobalization();
	return (
		<>
			<Grid xs={12} item>
				<FormControlLabel
					control={
						<Switch
							size="small"
							checked={isOverride}
							disabled={disabled}
							onChange={(_event, checked) => onToggle(checked)}
						/>
					}
					label={t('Override calculated cost')}
				/>
			</Grid>
			{isOverride && (
				<Grid xs={12} item>
					<CurrencyField
						fullWidth
						name="OverrideAmount"
						label={t('Override Amount')}
						variant="outlined"
						min={0}
						step={'1'}
						defaultValue={
							overrideAmount >= 0
								? overrideAmount.toFixed(2).toString()
								: '0'
						}
						onChange={onAmountChange}
					/>
					<Typography style={{ fontSize: '12px', color: '#768D95' }}>
						{t(
							'This amount will replace the calculated cost. The original calculation is preserved for reference.',
						)}
					</Typography>
				</Grid>
			)}
		</>
	);
};
